var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 9) scale(1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7778 19.8H4.22222V7.7H19.7778M16.4444 0V2.2H7.55556V0H5.33333V2.2H4.22222C2.98889 2.2 2 3.179 2 4.4V19.8C2 20.3835 2.23413 20.9431 2.65087 21.3556C3.06762 21.7682 3.63285 22 4.22222 22H19.7778C20.3671 22 20.9324 21.7682 21.3491 21.3556C21.7659 20.9431 22 20.3835 22 19.8V4.4C22 3.81652 21.7659 3.25695 21.3491 2.84437C20.9324 2.43179 20.3671 2.2 19.7778 2.2H18.6667V0M17.5556 12.1H12V17.6H17.5556V12.1Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCalendar);
export default __webpack_public_path__ + "static/media/mdi_calendar.f6b15a3509cc6f2268b9e0d0d0615539.svg";
export { ForwardRef as ReactComponent };